import React, { useCallback, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {  useNavigate, useSearchParams } from 'react-router-dom';
import {
  Form,
  Button,
  InputGroup,
  Badge,
  Row,
  Col,
  Nav,
  Alert,
  Table,
} from 'react-bootstrap';
import Select, { components } from 'react-select';
import ChannelHeader from './Channel_header';
import Opportunities from './Opportunities';
import Modal_proyectos from '../../menus/Modal';
import { load_channel_log, send_channel_newLogEntry } from '../../../utils/crm_services';
import {
  list_root_materials,
  create_root_material,
  load_root_material,
  update_root_material,
  delete_root_material,
  insert_root_materials_inventory_movement,
  list_root_materials_inventory_consolidated,
  load_root_material_inventory_movements,
} from '../../../utils/cas_services';
import './Channel_panel.css';

/** Normaliza fila API → opción react-select (value string para coincidir con JSON). */
function rootMaterialRowToSelectOption(r) {
  if (Array.isArray(r)) {
    const id = r[0];
    const nm = r[1];
    return {
      value: String(id),
      label: nm == null ? '' : String(nm).trim(),
    };
  }
  const id = r?.id ?? r?.ID;
  const rawName =
    r?.name ??
    r?.NAME ??
    r?.material_name ??
    r?.nombre ??
    r?.label ??
    '';
  const label =
    rawName === null || rawName === undefined ? '' : String(rawName).trim();
  return {
    value: String(id),
    label,
  };
}

function materialOptionLabel(opt) {
  if (!opt) return '';
  const t = opt.label ?? opt.name ?? '';
  const s = t === null || t === undefined ? '' : String(t).trim();
  return s || '(sin nombre)';
}

function findMaterialOptionByValue(options, value) {
  if (!value || options == null) return null;
  const key = String(value.value ?? value);
  return options.find((o) => String(o.value) === key) ?? null;
}

/** react-select v5: sin esto, value y options por referencia distinta muestran el id en el control. */
function materialOptionEqual(a, b) {
  if (!a || !b) return false;
  return String(a.value) === String(b.value);
}

function CasMaterialSingleValue(props) {
  const opts = props.selectProps.options || [];
  const matched = findMaterialOptionByValue(opts, props.data) || props.data;
  const text = materialOptionLabel(matched);
  return <components.SingleValue {...props}>{text}</components.SingleValue>;
}

function CasMaterialOption(props) {
  const onEdit = props.selectProps.onEditRawMaterial;
  const canManageRawMaterials = Boolean(props.selectProps.canManageRawMaterials);
  const text = materialOptionLabel(props.data);
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-center gap-2 w-100" style={{ minWidth: 0 }}>
        <span className="text-truncate flex-grow-1">{text}</span>
        {canManageRawMaterials ? (
          <button
            type="button"
            className="btn btn-link p-0 text-secondary flex-shrink-0 cas-material-option-edit"
            aria-label="Editar materia prima"
            title="Editar"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (typeof onEdit === 'function') onEdit(props.data);
            }}
          >
            <i className="bi bi-pencil" aria-hidden />
          </button>
        ) : null}
      </div>
    </components.Option>
  );
}

function CasMaterialsNoOptionsMessage(props) {
  const { selectProps } = props;
  const loading = selectProps.materialsLoading;
  const q = (selectProps.inputValue || '').trim();
  const onCreate = selectProps.onCreateRawMaterial;
  const canManageRawMaterials = Boolean(selectProps.canManageRawMaterials);

  if (loading) {
    return <div className="px-3 py-3 text-muted small">Cargando…</div>;
  }
  if (!q) {
    return <div className="px-3 py-3 text-muted small">Sin productos</div>;
  }
  if (!canManageRawMaterials) {
    return <div className="px-3 py-3 text-muted small">No hay coincidencias.</div>;
  }
  return (
    <div className="px-2 py-2">
      <div className="text-muted small mb-2">No hay coincidencias.</div>
      <button
        type="button"
        className="btn btn-link text-danger p-0 text-start text-decoration-none"
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof onCreate === 'function') onCreate(q);
        }}
      >
        Crear nueva materia prima
      </button>
    </div>
  );
}

function formatInventoryDate(dt) {
  if (!dt) return '—';
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return String(dt);
  return d.toLocaleString();
}

function Channel_panel  ({user_id, permission, usr_type}) {
    // --- Estado de filtros/orden/columnas ---
     // Log
  const token = localStorage.getItem("token");
  const [logEntry, setLogEntry] = useState('');
  const [channel_name, setchannel_name] = useState('');
  const [log, setLog] = useState([]);
  const [isCasAuthorized, setIsCasAuthorized] = useState(false);
  const [channelCanManage, setChannelCanManage] = useState(parseInt(usr_type, 10) === 0);
  const [mainTab, setMainTab] = useState('negocios');
  const [inventoryModalOpen, setInventoryModalOpen] = useState(false);
  const [inventoryProductOptions, setInventoryProductOptions] = useState([]);
  const [inventoryMaterialsLoading, setInventoryMaterialsLoading] = useState(false);
  const [inventoryProduct, setInventoryProduct] = useState(null);
  const [inventoryQty, setInventoryQty] = useState('');
  const [inventoryReferencia, setInventoryReferencia] = useState('');
  const [inventoryDescripcion, setInventoryDescripcion] = useState('');
  const [inventoryProductTouched, setInventoryProductTouched] = useState(false);
  const [inventoryQtyTouched, setInventoryQtyTouched] = useState(false);
  const [inventoryMovementSaving, setInventoryMovementSaving] = useState(false);
  const [inventoryMovementError, setInventoryMovementError] = useState('');
  const [inventoryView, setInventoryView] = useState('summary');
  const [inventorySummaryRows, setInventorySummaryRows] = useState([]);
  const [inventorySummaryLoading, setInventorySummaryLoading] = useState(false);
  const [inventorySummaryError, setInventorySummaryError] = useState('');
  const [inventoryDetailRows, setInventoryDetailRows] = useState([]);
  const [inventoryDetailLoading, setInventoryDetailLoading] = useState(false);
  const [inventoryDetailError, setInventoryDetailError] = useState('');
  const [inventoryDetailProduct, setInventoryDetailProduct] = useState(null);
  const [inventorySelectMenuOpen, setInventorySelectMenuOpen] = useState(false);
  const [createMaterialModalOpen, setCreateMaterialModalOpen] = useState(false);
  const [editMaterialId, setEditMaterialId] = useState(null);
  const [materialFormLoading, setMaterialFormLoading] = useState(false);
  const [newMaterialName, setNewMaterialName] = useState('');
  const [newMaterialDescription, setNewMaterialDescription] = useState('');
  const [newMaterialCost, setNewMaterialCost] = useState('');
  const [newMaterialNameTouched, setNewMaterialNameTouched] = useState(false);
  const [createMaterialSaving, setCreateMaterialSaving] = useState(false);
  const [createMaterialError, setCreateMaterialError] = useState('');
  const [searchParams] = useSearchParams();
  const channel_id = searchParams.get("chid");
  const navigate = useNavigate();
  const canManageRawMaterials =
    parseInt(permission, 10) === 1 && parseInt(usr_type, 10) === 0;

  const newMaterialNameInvalid =
    newMaterialNameTouched && !String(newMaterialName).trim();

  const inventoryProductInvalid =
    inventoryProductTouched && !inventoryProduct;

  const inventoryQtyNum = parseInt(String(inventoryQty).trim(), 10);
  const inventoryQtyInvalid =
    inventoryQtyTouched &&
    (!Number.isFinite(inventoryQtyNum) || inventoryQtyNum < 1);

  const resetInventoryMovementForm = () => {
    setInventoryProduct(null);
    setInventoryQty('');
    setInventoryReferencia('');
    setInventoryDescripcion('');
    setInventoryProductTouched(false);
    setInventoryQtyTouched(false);
    setInventoryMovementSaving(false);
    setInventoryMovementError('');
  };

  const closeInventoryMovementModal = () => {
    setInventoryModalOpen(false);
    setInventoryMaterialsLoading(false);
    setInventorySelectMenuOpen(false);
    resetInventoryMovementForm();
  };

  const loadInventorySummary = useCallback(async () => {
    if (!channel_id || String(channel_id).trim() === '') return;
    setInventorySummaryLoading(true);
    setInventorySummaryError('');
    const rows = await list_root_materials_inventory_consolidated(token, channel_id);
    setInventorySummaryLoading(false);
    if (rows === 'INVALID') {
      navigate('/');
      return;
    }
    if (Array.isArray(rows)) {
      setInventorySummaryRows(rows);
    } else {
      setInventorySummaryRows([]);
      setInventorySummaryError('No se pudo cargar el consolidado de inventario.');
    }
  }, [channel_id, navigate, token]);

  const openInventoryDetail = useCallback(async (product) => {
    if (!channel_id || !product || !product.root_material_id) return;
    setInventoryDetailProduct(product);
    setInventoryDetailRows([]);
    setInventoryDetailError('');
    setInventoryDetailLoading(true);
    setInventoryView('detail');

    const rows = await load_root_material_inventory_movements(
      token,
      channel_id,
      product.root_material_id
    );
    setInventoryDetailLoading(false);
    if (rows === 'INVALID') {
      navigate('/');
      return;
    }
    if (Array.isArray(rows)) {
      setInventoryDetailRows(rows);
    } else {
      setInventoryDetailError('No se pudo cargar el detalle de movimientos.');
    }
  }, [channel_id, navigate, token]);

  const submitInventoryMovement = async () => {
    setInventoryProductTouched(true);
    setInventoryQtyTouched(true);
    if (!inventoryProduct) return;
    if (!Number.isFinite(inventoryQtyNum) || inventoryQtyNum < 1) return;
    if (!channel_id || String(channel_id).trim() === '') {
      setInventoryMovementError('No hay canal seleccionado.');
      return;
    }
    setInventoryMovementSaving(true);
    setInventoryMovementError('');
    const res = await insert_root_materials_inventory_movement(
      token,
      channel_id,
      inventoryProduct.value,
      inventoryQtyNum,
      inventoryReferencia.trim(),
      inventoryDescripcion.trim()
    );
    setInventoryMovementSaving(false);
    if (res === 'INVALID') {
      navigate('/');
      return;
    }
    if (res && res.ok) {
      await loadInventorySummary();
      if (
        inventoryDetailProduct &&
        String(inventoryDetailProduct.root_material_id) === String(inventoryProduct.value)
      ) {
        await openInventoryDetail(inventoryDetailProduct);
      }
      closeInventoryMovementModal();
    } else {
      if (res && res.debug) {
        console.error('insert_root_materials_inventory:', res.debug);
      }
      const mysql =
        res && res.debug && (res.debug.mysqli_error || res.debug.exception_message)
          ? `\n${res.debug.mysqli_error || res.debug.exception_message}`
          : '';
      setInventoryMovementError(
        ((res && res.error) ? res.error : 'No se pudo registrar el movimiento.') +
          mysql +
          (res && res.debug ? '\n\nDetalle completo en consola (F12).' : '')
      );
    }
  };

  const openCreateRawMaterialModal = useCallback((prefillName) => {
    if (!canManageRawMaterials) return;
    setInventorySelectMenuOpen(false);
    setEditMaterialId(null);
    setMaterialFormLoading(false);
    setNewMaterialName(prefillName || '');
    setNewMaterialDescription('');
    setNewMaterialCost('');
    setNewMaterialNameTouched(false);
    setCreateMaterialError('');
    setCreateMaterialModalOpen(true);
  }, [canManageRawMaterials]);

  const closeCreateMaterialModal = () => {
    setCreateMaterialModalOpen(false);
    setEditMaterialId(null);
    setMaterialFormLoading(false);
    setNewMaterialName('');
    setNewMaterialDescription('');
    setNewMaterialCost('');
    setNewMaterialNameTouched(false);
    setCreateMaterialSaving(false);
    setCreateMaterialError('');
  };

  const openEditRawMaterial = useCallback(
    async (option) => {
      if (!canManageRawMaterials) return;
      setInventorySelectMenuOpen(false);
      const id = String(option?.value ?? '');
      if (!id) return;
      setEditMaterialId(id);
      setNewMaterialNameTouched(false);
      setCreateMaterialError('');
      setNewMaterialName('');
      setNewMaterialDescription('');
      setNewMaterialCost('');
      setCreateMaterialModalOpen(true);
      setMaterialFormLoading(true);
      const row = await load_root_material(token, id);
      setMaterialFormLoading(false);
      if (row === 'INVALID' || row === null) {
        navigate('/');
        return;
      }
      if (row && row.ok && row.id != null) {
        setNewMaterialName(String(row.name ?? ''));
        setNewMaterialDescription(
          row.description == null ? '' : String(row.description)
        );
        setNewMaterialCost(
          row.cost === null || row.cost === undefined || row.cost === ''
            ? ''
            : String(row.cost)
        );
      } else {
        setCreateMaterialError(
          (row && row.error) ? row.error : 'No se pudo cargar el producto.'
        );
      }
    },
    [canManageRawMaterials, token, navigate]
  );

  const submitNewRootMaterial = async () => {
    if (!canManageRawMaterials) return;
    setNewMaterialNameTouched(true);
    if (!String(newMaterialName).trim()) return;
    setCreateMaterialSaving(true);
    setCreateMaterialError('');
    const res = editMaterialId
      ? await update_root_material(
          token,
          editMaterialId,
          newMaterialName.trim(),
          newMaterialDescription.trim(),
          newMaterialCost.trim()
        )
      : await create_root_material(
          token,
          newMaterialName.trim(),
          newMaterialDescription.trim(),
          newMaterialCost.trim()
        );
    setCreateMaterialSaving(false);
    if (res === 'INVALID') {
      navigate('/');
      return;
    }
    if (res && res.ok && res.id != null) {
      const rows = await list_root_materials(token);
      if (rows === 'INVALID') {
        navigate('/');
        return;
      }
      if (Array.isArray(rows)) {
        setInventoryProductOptions(rows.map(rootMaterialRowToSelectOption));
      }
      setInventoryProduct({
        value: String(res.id),
        label: String(res.name ?? newMaterialName).trim(),
      });
      setInventoryProductTouched(true);
      closeCreateMaterialModal();
    } else {
      setCreateMaterialError(
        (res && res.error)
          ? res.error
          : editMaterialId
            ? 'No se pudo actualizar la materia prima.'
            : 'No se pudo crear la materia prima.'
      );
    }
  };

  const deleteRootMaterialConfirmed = async () => {
    if (!canManageRawMaterials) return;
    if (!editMaterialId) return;
    const msg =
      '¿Eliminar esta materia prima? Esta acción no se puede deshacer.';
    if (!window.confirm(msg)) return;
    setCreateMaterialSaving(true);
    setCreateMaterialError('');
    const res = await delete_root_material(token, editMaterialId);
    setCreateMaterialSaving(false);
    if (res === 'INVALID') {
      navigate('/');
      return;
    }
    if (res && res.ok) {
      const rows = await list_root_materials(token);
      if (rows === 'INVALID') {
        navigate('/');
        return;
      }
      if (Array.isArray(rows)) {
        setInventoryProductOptions(rows.map(rootMaterialRowToSelectOption));
      }
      setInventoryProduct((cur) => {
        if (cur && String(cur.value) === String(editMaterialId)) return null;
        return cur;
      });
      closeCreateMaterialModal();
    } else {
      setCreateMaterialError(
        (res && res.error) ? res.error : 'No se pudo eliminar.'
      );
    }
  };

  useEffect(() => {
    setIsCasAuthorized(false);
    setMainTab('negocios');
    setInventoryView('summary');
    setInventorySummaryRows([]);
    setInventoryDetailRows([]);
    setInventoryDetailProduct(null);
    setInventorySummaryError('');
    setInventoryDetailError('');
  }, [channel_id]);

  const onCasAuthorizedChange = useCallback((authorized, loadedForChannelId) => {
    if (String(loadedForChannelId) !== String(channel_id)) return;
    setIsCasAuthorized(authorized);
  }, [channel_id]);

  const onChannelAdminChange = useCallback((canManage) => {
    setChannelCanManage(Boolean(canManage));
  }, []);
  
    const sendLog = () => {
    
      if (!logEntry.trim()) return;
      
      sendNewLogEntry();

      setLogEntry('');

    };

    
    async function sendNewLogEntry() {
      const productList = await send_channel_newLogEntry(token,channel_id, logEntry);
      if (productList==="INVALID"){
          navigate("/");
      }else{
         load_log();
  
      }
    }

    useEffect(() => {
      if (channel_id !== null) {
        
            load_log();
       
      }
    }, [channel_id]); 
    

    
    async function load_log() {
        const channel_log = await load_channel_log(token,channel_id);
        if (channel_log==="INVALID"){
            navigate("/");
        }else{
    
         const templog= channel_log.map((celement, index) => {
           return {
               id: celement.id,
               issue_date: celement.issue_date,
               description: celement.description,
               type_name: celement.type_name,
               issue_type: celement.type,
               user_by: celement.usr_name,
               index:index
           };
         });
    
          setLog( templog);
            
        }
    }

    

    useEffect(() => {
      if (!inventoryModalOpen || !token) return undefined;
      let cancelled = false;
      setInventoryMaterialsLoading(true);
      (async () => {
        const rows = await list_root_materials(token);
        if (cancelled) return;
        setInventoryMaterialsLoading(false);
        if (rows === 'INVALID') {
          navigate('/');
          return;
        }
        if (Array.isArray(rows)) {
          setInventoryProductOptions(rows.map(rootMaterialRowToSelectOption));
        } else {
          setInventoryProductOptions([]);
        }
      })();
      return () => {
        cancelled = true;
        setInventoryMaterialsLoading(false);
      };
    }, [inventoryModalOpen, token, navigate]);

    useEffect(() => {
      if (!inventoryModalOpen || inventoryProductOptions.length === 0) return;
      setInventoryProduct((cur) => {
        if (!cur) return cur;
        const found = findMaterialOptionByValue(inventoryProductOptions, cur);
        return found || cur;
      });
    }, [inventoryModalOpen, inventoryProductOptions]);

  useEffect(() => {
    if (!isCasAuthorized) return;
    if (mainTab !== 'inventario_cas') return;
    setInventoryView('summary');
    setInventoryDetailRows([]);
    setInventoryDetailProduct(null);
    loadInventorySummary();
  }, [isCasAuthorized, mainTab, loadInventorySummary]);

    const negociosSection = (
      <div>
        <Opportunities
          channel_id={channel_id}
          channel_name={channel_name}
          user_id={user_id}
          permission={permission}
          usr_type={usr_type}
          channelCanManage={channelCanManage}
        />
        <Row className="mt-4 text-start">
          <Col>
            <Form.Label>Opportunity Log:</Form.Label>
            <InputGroup className="mb-2">
              <Form.Control
                placeholder="Add a log entry..."
                value={logEntry}
                onChange={(e) => setLogEntry(e.target.value)}
              />
              <Button variant="primary" onClick={sendLog}>
                &#9658;
              </Button>
            </InputGroup>
            <div className="log-box text-left">
              {log.length === 0 ? (
                <p className="text-gray-500 italic">No hay entradas en el registro aún.</p>
              ) : (
                log.map((l) => (
                  <div key={l.id} className="bg-light p-3 rounded mb-3 shadow-sm border">
                    <div className="d-flex flex-column flex-sm-row align-items-sm-baseline mb-2 gap-3">
                      <Badge
                        bg="warning"
                        pill
                        className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                      >
                        {l.user_by}
                      </Badge>
                      <span className="text-muted small">
                        {new Date(l.issue_date).toLocaleString()}
                      </span>
                      <Badge
                        bg={ l.issue_type == 1 ? 'danger' :  l.issue_type == 2 ? 'info': l.issue_type == 3 ? 'secondary':'warning'}
                        pill
                        className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                      >
                        {l.type_name}
                      </Badge>
                    </div>
                    <p className="text-dark lh-sm text-start">{l.description}</p>
                  </div>
                ))
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    // ---------- UI ----------
    return (
      <div className="channel-panel-root pt-2 pb-4">
        <ChannelHeader
          channel_id={channel_id}
          usr_type={usr_type}
          token = {token}
          score={5}
          onSet = {(name) => setchannel_name(name)}
          onCasAuthorizedChange={onCasAuthorizedChange}
          onChannelAdminChange={onChannelAdminChange}
       />

    {isCasAuthorized ? (
      <>
        <Nav
          variant="tabs"
          activeKey={mainTab}
          onSelect={(k) => k && setMainTab(k)}
          className="channel-panel-crm-tabs mb-2"
        >
          <Nav.Item>
            <Nav.Link eventKey="negocios">Negocios</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="inventario_cas">Inventario de CAS</Nav.Link>
          </Nav.Item>
        </Nav>
        {mainTab === 'negocios' && negociosSection}
        {mainTab === 'inventario_cas' && (
          <>
            <div className="cas-inventory-tab">
              {inventoryView === 'summary' ? (
                <div className="border rounded bg-white p-2">
                  {inventorySummaryError ? (
                    <Alert variant="danger" className="mb-2 py-2">
                      {inventorySummaryError}
                    </Alert>
                  ) : null}
                  <Table hover responsive className="mb-0 align-middle">
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th className="text-end">Stock actual</th>
                        <th className="text-end">Movimientos</th>
                        <th>Ultimo movimiento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inventorySummaryLoading ? (
                        <tr>
                          <td colSpan={4} className="text-center text-muted py-4">
                            Cargando inventario...
                          </td>
                        </tr>
                      ) : inventorySummaryRows.length === 0 ? (
                        <tr>
                          <td colSpan={4} className="text-center text-muted py-4">
                            Sin movimientos registrados.
                          </td>
                        </tr>
                      ) : (
                        inventorySummaryRows.map((r) => (
                          <tr
                            key={`inv-s-${r.root_material_id}`}
                            className="cas-inventory-row"
                            onClick={() => openInventoryDetail(r)}
                            style={{ cursor: 'pointer' }}
                          >
                            <td>{r.root_material_name || `#${r.root_material_id}`}</td>
                            <td className="text-end fw-semibold">{r.qty_balance}</td>
                            <td className="text-end">{r.movements_count}</td>
                            <td>{formatInventoryDate(r.last_movement_at)}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="border rounded bg-white p-2">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <Button
                      variant="link"
                      className="text-decoration-none p-0"
                      onClick={() => {
                        setInventoryView('summary');
                        setInventoryDetailRows([]);
                        setInventoryDetailError('');
                      }}
                    >
                      <i className="bi bi-arrow-left me-1" />
                      Volver al consolidado
                    </Button>
                    <span className="small text-muted">
                      {inventoryDetailProduct?.root_material_name || ''}
                    </span>
                  </div>
                  {inventoryDetailError ? (
                    <Alert variant="danger" className="mb-2 py-2">
                      {inventoryDetailError}
                    </Alert>
                  ) : null}
                  <Table responsive className="mb-0 align-middle">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th className="text-end">Cantidad</th>
                        <th>Tipo</th>
                        <th>Usuario</th>
                        <th>Ref</th>
                        <th>Descripcion</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inventoryDetailLoading ? (
                        <tr>
                          <td colSpan={6} className="text-center text-muted py-4">
                            Cargando movimientos...
                          </td>
                        </tr>
                      ) : inventoryDetailRows.length === 0 ? (
                        <tr>
                          <td colSpan={6} className="text-center text-muted py-4">
                            Sin movimientos para este producto.
                          </td>
                        </tr>
                      ) : (
                        inventoryDetailRows.map((m) => (
                          <tr key={`inv-d-${m.id}`}>
                            <td>{formatInventoryDate(m.date_time)}</td>
                            <td className="text-end">{m.qty}</td>
                            <td>{m.type === 0 ? 'IN' : m.type === 1 ? 'OUT' : m.type}</td>
                            <td>{m.usr_name || `#${m.usr_id}`}</td>
                            <td>{m.ref || '—'}</td>
                            <td>{m.description || '—'}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
              <div className="cas-inventory-fab-wrap">
                <Button
                  variant="danger"
                  className="cas-inventory-fab-btn rounded-circle"
                  onClick={() => {
                    setInventoryMovementError('');
                    setInventoryModalOpen(true);
                  }}
                  aria-label="Nuevo movimiento de inventario"
                  type="button"
                >
                  +
                </Button>
              </div>
            </div>
            <Modal_proyectos
              isOpen={inventoryModalOpen}
              onClose={closeInventoryMovementModal}
              title="Nuevo movimiento de inventario"
              overlayClassName="modal-overlay--elevated"
              contentClassName="cas-inventory-modal-content"
            >
              <div className="modal-inner">
                {inventoryMovementError ? (
                  <Alert variant="danger" className="mb-3 py-2" dismissible onClose={() => setInventoryMovementError('')}>
                    {inventoryMovementError}
                  </Alert>
                ) : null}
                <Form.Group className="mb-3">
                  <Form.Label>Producto <span className="text-danger">*</span></Form.Label>
                  <Select
                    classNamePrefix="react-select"
                    components={{
                      NoOptionsMessage: CasMaterialsNoOptionsMessage,
                      SingleValue: CasMaterialSingleValue,
                      Option: CasMaterialOption,
                    }}
                    canManageRawMaterials={canManageRawMaterials}
                    materialsLoading={inventoryMaterialsLoading}
                    onCreateRawMaterial={openCreateRawMaterialModal}
                    onEditRawMaterial={openEditRawMaterial}
                    menuIsOpen={inventorySelectMenuOpen}
                    onMenuOpen={() => setInventorySelectMenuOpen(true)}
                    onMenuClose={() => setInventorySelectMenuOpen(false)}
                    options={inventoryProductOptions}
                    value={inventoryProduct}
                    onChange={(opt) => {
                      setInventoryProduct(opt);
                      setInventoryProductTouched(true);
                    }}
                    onBlur={() => setInventoryProductTouched(true)}
                    placeholder="Seleccionar producto…"
                    isClearable
                    isSearchable
                    isLoading={inventoryMaterialsLoading}
                    blurInputOnSelect
                    getOptionValue={(opt) => String(opt.value)}
                    getOptionLabel={(opt) => materialOptionLabel(opt)}
                    isOptionEqualToValue={materialOptionEqual}
                    styles={{
                      control: (base) => ({
                        ...base,
                        ...(inventoryProductInvalid
                          ? {
                              borderColor: '#dc3545',
                              boxShadow: '0 0 0 0.2rem rgba(220, 53, 69, 0.2)',
                            }
                          : {}),
                      }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    menuPosition="fixed"
                  />
                  {inventoryProductInvalid ? (
                    <Form.Control.Feedback type="invalid" className="d-block">
                      Seleccione un producto.
                    </Form.Control.Feedback>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Cantidad <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="number"
                    min={1}
                    step={1}
                    value={inventoryQty}
                    onChange={(e) => setInventoryQty(e.target.value)}
                    onBlur={() => setInventoryQtyTouched(true)}
                    isInvalid={inventoryQtyInvalid}
                    placeholder="Unidades"
                  />
                  {inventoryQtyInvalid ? (
                    <Form.Control.Feedback type="invalid">
                      Indique un entero mayor o igual a 1.
                    </Form.Control.Feedback>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Referencia</Form.Label>
                  <Form.Control
                    type="text"
                    value={inventoryReferencia}
                    onChange={(e) => setInventoryReferencia(e.target.value)}
                    placeholder="Opcional"
                  />
                </Form.Group>
                <Form.Group className="mb-0">
                  <Form.Label>Descripción</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={inventoryDescripcion}
                    onChange={(e) => setInventoryDescripcion(e.target.value)}
                    placeholder="Opcional"
                  />
                </Form.Group>
              </div>
              <div className="modal-footer-fixed">
                <Button
                  variant="outline-secondary"
                  type="button"
                  disabled={inventoryMovementSaving}
                  onClick={closeInventoryMovementModal}
                >
                  Cancelar
                </Button>
                <Button
                  variant="danger"
                  type="button"
                  disabled={inventoryMovementSaving}
                  onClick={submitInventoryMovement}
                >
                  {inventoryMovementSaving ? 'Guardando…' : 'Agregar'}
                </Button>
              </div>
            </Modal_proyectos>
            <Modal_proyectos
              isOpen={createMaterialModalOpen}
              onClose={closeCreateMaterialModal}
              title={editMaterialId ? 'Editar materia prima' : 'Nueva materia prima'}
              overlayClassName="modal-overlay modal-overlay--stack"
              contentClassName="cas-inventory-modal-content"
            >
              <div className="modal-inner">
                {createMaterialError ? (
                  <Alert variant="danger" className="mb-3 py-2" dismissible onClose={() => setCreateMaterialError('')}>
                    {createMaterialError}
                  </Alert>
                ) : null}
                {materialFormLoading ? (
                  <p className="text-muted small py-4 text-center mb-0">Cargando…</p>
                ) : (
                  <>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={newMaterialName}
                    onChange={(e) => setNewMaterialName(e.target.value)}
                    onBlur={() => setNewMaterialNameTouched(true)}
                    isInvalid={newMaterialNameInvalid}
                    placeholder="Nombre de la materia prima"
                  />
                  {newMaterialNameInvalid ? (
                    <Form.Control.Feedback type="invalid">Indique un nombre.</Form.Control.Feedback>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Descripción</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={newMaterialDescription}
                    onChange={(e) => setNewMaterialDescription(e.target.value)}
                    placeholder="Opcional"
                  />
                </Form.Group>
                <Form.Group className="mb-0">
                  <Form.Label>Precio USD</Form.Label>
                  <Form.Control
                    type="text"
                    inputMode="decimal"
                    value={newMaterialCost}
                    onChange={(e) => setNewMaterialCost(e.target.value)}
                    placeholder="Opcional"
                  />
                </Form.Group>
                  </>
                )}
              </div>
              <div className="modal-footer-fixed d-flex flex-wrap justify-content-between align-items-center gap-2">
                <div>
                  {canManageRawMaterials && editMaterialId && !materialFormLoading ? (
                    <Button
                      variant="outline-danger"
                      type="button"
                      disabled={createMaterialSaving}
                      onClick={deleteRootMaterialConfirmed}
                    >
                      Eliminar
                    </Button>
                  ) : null}
                </div>
                <div className="d-flex gap-2 ms-auto">
                <Button
                  variant="outline-secondary"
                  type="button"
                  disabled={createMaterialSaving || materialFormLoading}
                  onClick={closeCreateMaterialModal}
                >
                  Cancelar
                </Button>
                <Button
                  variant="danger"
                  type="button"
                  disabled={!canManageRawMaterials || createMaterialSaving || materialFormLoading}
                  onClick={submitNewRootMaterial}
                >
                  {createMaterialSaving ? 'Guardando…' : 'Guardar'}
                </Button>
                </div>
              </div>
            </Modal_proyectos>
          </>
        )}
      </>
    ) : (
      negociosSection
    )}

      </div>
    );
};

export default Channel_panel;
